<script lang="ts">
	import type { SeoMetaTagData } from '$lib/queries/datoCMS/DatoCMSQueries';

	const { data }: { data: SeoMetaTagData[] } = $props();
</script>

<svelte:head>
	{#each data as { tag, attributes, content }}
		<!-- NOTE: We don't use the <svelte:element> setup because of -->
		<!-- svelte 5 SSR fragments being output as comments in all HTML elements, -->
		<!-- including <title>, <script>, and <style>, which breaks everything -->
		<!-- {#if content} -->
		<!-- 	<svelte:element this={tag} {...attributes}>{content}</svelte:element> -->
		<!-- {:else} -->
		<!-- 	<svelte:element this={tag} {...attributes} /> -->
		<!-- {/if} -->

		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html `<${tag} ${
			attributes
				? Object.keys(attributes)
						?.map((key) => `${key}="${attributes?.[key]}"`)
						.join(' ')
				: ''
		} ${content ? `>${content}</${tag}>` : `/>`}`}
	{/each}
</svelte:head>
